import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const StyledImage = styled.img`
  width: ${props => props.width || '100%'};
  height: ${props => props.height};
`

const Image = ({ src, alt, width, height, className, ...custom }) => {
  return (
    <StyledImage
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      {...custom}
    />
  )
}

Image.propTypes = {
  /**
   * Pass the source of the image
   */
  src: PropTypes.string.isRequired,

  /**
   * Alternate text to show if image does not load
   */

  alt: PropTypes.string,

  /**
   * Width of image with any unit as in CSS
   */
  width: PropTypes.string,

  /**
   * Height of image with any unit as in CSS
   */
  height: PropTypes.string
}

Image.defaultProps = {
  src: '',
  alt: 'An image',
  width: '',
  height: ''
}

export default Image



// WEBPACK FOOTER //
// ./src/components/UI/Image/index.js